export default __webpack_public_path__ + "static/media/illustration-algowork-w@3x.f4dbde78.webp";